import React from 'react';
import { RouteObject } from 'react-router-dom';
import Employees from './pages/Employees';
import CreateEmployee from './pages/CreateEmployee';
import UpdateEmployee from './pages/UpdateEmployee';
 const employeeRoutes: RouteObject[] = [
    {
        index: true,
        element: <Employees />
    },
    {
        path: 'create',
        element: <CreateEmployee />
    },
    {
        path: ':id/edit',
        element: <UpdateEmployee />
    }
];

export default employeeRoutes;